var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocumentCopyIndigo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 8.11506C3.47018 8.11506 3.75 8.39488 3.75 8.74006V15.4067C3.75 16.9025 4.96256 18.1151 6.45833 18.1151H11.4583C11.8035 18.1151 12.0833 18.3949 12.0833 18.7401C12.0833 19.0852 11.8035 19.3651 11.4583 19.3651H6.45833C4.27221 19.3651 2.5 17.5929 2.5 15.4067V8.74006C2.5 8.39488 2.77982 8.11506 3.125 8.11506Z",
    fill: "#1C3D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29167 3.11523C6.71637 3.11523 6.25 3.5816 6.25 4.1569V14.5734C6.25 15.1487 6.71637 15.6151 7.29167 15.6151H14.9166C15.4919 15.6151 15.9583 15.1487 15.9583 14.5734V8.05266C15.9583 7.99912 15.9376 7.94763 15.9007 7.90888L11.3905 3.17978C11.3512 3.13856 11.2967 3.11523 11.2397 3.11523H7.29167ZM5 4.1569C5 2.89125 6.02601 1.86523 7.29167 1.86523H11.2397C11.6385 1.86523 12.0198 2.02852 12.2951 2.31708L16.8053 7.04618C17.0639 7.31742 17.2083 7.67785 17.2083 8.05266V14.5734C17.2083 15.839 16.1822 16.8651 14.9166 16.8651H7.29167C6.02601 16.8651 5 15.839 5 14.5734V4.1569Z",
    fill: "#1C3D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5833 1.86523C11.9284 1.86523 12.2083 2.14506 12.2083 2.49023V7.08537C12.2083 7.20066 12.3019 7.29403 12.4172 7.2937L16.5815 7.2819C16.9267 7.28093 17.2073 7.55995 17.2082 7.90513C17.2092 8.25031 16.9302 8.53092 16.585 8.5319L12.4207 8.54369C11.6137 8.54598 10.9583 7.8924 10.9583 7.08537V2.49023C10.9583 2.14506 11.2381 1.86523 11.5833 1.86523Z",
    fill: "#1C3D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentCopyIndigo);
export default __webpack_public_path__ + "static/media/icon-document-copy-indigo.8d1f55be5d605d84748ac719d5745dbe.svg";
export { ForwardRef as ReactComponent };